export default function CTABanner() {
  return (
    <section className="bg-[#0F172A] py-12 px-6 border-t border-white/10">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-6">
        <div className="flex flex-col gap-2 text-center lg:text-left">
          <h2
            className="text-white text-3xl xl:text-4xl leading-tight"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900, letterSpacing: '-0.05em' }}
          >
            Formulate with Precision.
          </h2>
          <p className="text-[#94a3b8] text-sm max-w-lg" style={{ fontFamily: 'Inter, sans-serif' }}>
            Connect with the Foraged Fuel laboratory for COAs and pricing. Our technical team responds
            within one business day with full documentation and custom-tier quotes.
          </p>
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <a
            href="tel:9548655411"
            className="bg-white text-[#0F172A] text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#F8F9FA] transition-colors whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Contact
          </a>
          <div className="text-[#475569] text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
            <span className="text-[#94a3b8] text-xs block">Direct Line</span>
            <a
              href="tel:9548655411"
              className="text-white font-semibold hover:text-[#94a3b8] transition-colors whitespace-nowrap cursor-pointer"
            >
              (954) 865-5411
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
